<div class="assign-to-body">
  <div class="form-group">
    <div class="uba-control-group">
      <label 
        id="label_users"
        for="ddl_users"
        class="k-form-field" 
        [translate]="'components.assignTo.assignTo'"></label>
      <div class="uba-form-control">
        <select 
          autoFocus
          *ngIf="users && users.length > 0"
          id="ddl_users"
          class="form-control"
          [(ngModel)]="selectedUserId"
          aria-describedby="users-help">
          <option *ngFor="let user of users" [ngValue]="user.value">{{ user.text }}</option>
        </select>
        <small id="users-help">{{ 'components.assignTo.assignToHelp' | translate }}</small>
      </div>
    </div>
  </div>
  <div class="uba-button-group">
    <button (click)="cancel()" class="btn btn-default" id="btn-cancel">
      {{ 'action.cancel' | translate }}
    </button>
    <button (click)="assign()" [disabled]="!canAssign" class="btn btn-primary" id="btn-assign">
      <i class="fas fa-people-arrows" aria-hidden="true"></i>
      {{ 'action.assign' | translate }}
    </button>
  </div>
</div>
